
export const storage = {
  getToken: () => {
    return localStorage.getItem('token') || sessionStorage.getItem('token');
  },

  getUser: () => {
    try {
      const userData = localStorage.getItem('user') || sessionStorage.getItem('user');
      return userData ? JSON.parse(userData) : null;
    } catch (error) {
      return null;
    }
  },

  setToken: (token, rememberMe = false) => {
    const storage = rememberMe ? localStorage : sessionStorage;
    storage.setItem('token', token);
  },

  setUser: (userData, rememberMe = false) => {
    const storage = rememberMe ? localStorage : sessionStorage;
    storage.setItem('user', JSON.stringify(userData));
  },

  clearAuth: () => {
    localStorage.removeItem('token');
    sessionStorage.removeItem('token');
    localStorage.removeItem('user');
    sessionStorage.removeItem('user');
  },
  getRememberedEmail: () => {
    return localStorage.getItem('rememberedEmail') || '';
  },

  setRememberedEmail: (email) => {
    if (email) {
      localStorage.setItem('rememberedEmail', email);
    }
  },

  clearRememberedEmail: () => {
    localStorage.removeItem('rememberedEmail');
  },

  isAuthenticated: () => {
    const token = storage.getToken();
    const userData = storage.getUser();
    return !!(token && userData);
  }
};

export const tokenUtils = {
  isValid: (token) => {
    if (!token) return false;
    
    const parts = token.split('.');
    return parts.length === 3;
  },

  getExpiration: (token) => {
    try {
      if (!token) return null;
      
      const parts = token.split('.');
      if (parts.length !== 3) return null;
      
      const payload = JSON.parse(atob(parts[1]));
      return payload.exp ? new Date(payload.exp * 1000) : null;
    } catch (error) {
      return null;
    }
  },

  isExpired: (token) => {
    const expiration = tokenUtils.getExpiration(token);
    if (!expiration) return false;
    
    return new Date() > expiration;
  }
};

export const apiUtils = {
  handleSuccess: (response, defaultMessage = 'Operation successful') => {
    return {
      success: true,
      data: response.data?.data || response.data,
      message: response.data?.message || defaultMessage,
      meta: response.data?.meta || null
    };
  },

  handleError: (error, defaultMessage = 'An error occurred') => {
    if (error.response) {
      const status = error.response.status;
      const serverMessage = error.response.data?.message;
      if (status === 401) return { success: false, message: 'Sesi telah berakhir. Silakan login kembali.', status };
      if (status === 403) return { success: false, message: serverMessage || 'Anda tidak memiliki akses.', status };
      if (status === 404) return { success: false, message: 'Data tidak ditemukan.', status };
      if (status === 422) return { success: false, message: serverMessage || 'Data tidak valid.', status };
      if (status >= 500) return { success: false, message: 'Terjadi kesalahan server.', status };
      return { success: false, message: serverMessage || defaultMessage, status };
    } else if (error.request) {
      return {
        success: false,
        message: 'Tidak dapat terhubung ke server.',
        status: 0
      };
    } else {
      return {
        success: false,
        message: defaultMessage,
        status: 0
      };
    }
  }
};

export const dateUtils = {
  formatIndonesian: (dateString) => {
    if (!dateString) return '-';
    const date = new Date(dateString);
    return date.toLocaleDateString('id-ID');
  },

  formatISO: (dateString) => {
    if (!dateString) return '';
    return new Date(dateString).toISOString().split('T')[0];
  },

  getDateRange: (months = 3) => {
    const today = new Date();
    const futureDate = new Date();
    futureDate.setMonth(today.getMonth() + months);
    
    return {
      start: dateUtils.formatISO(today),
      end: dateUtils.formatISO(futureDate)
    };
  }
};

export const validation = {
  isValidEmail: (email) => {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailRegex.test(email);
  },

  isValidDomain: (domain) => {
    const domainRegex = /^([a-zA-Z0-9]([a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?\.)+[a-zA-Z]{2,}$/;
    return domainRegex.test(domain);
  },

  isValidPhone: (phone) => {
    const phoneRegex = /^(\+62|62|0)[0-9]{9,13}$/;
    return phoneRegex.test(phone);
  },

  /**
   * @param {string} password
   * @returns {object}}
   */
  validatePassword: (password, isRequired = true) => {
    if (isRequired && !password) {
      return {
        isValid: false,
        error: "Password is required"
      };
    }

    if (!isRequired && !password) {
      return {
        isValid: true,
        error: ""
      };
    }

    if (password.length < 6) {
      return {
        isValid: false,
        error: "Password must be at least 6 characters long and contain a mix of letters, numbers, and special characters for better security."
      };
    }

    const hasLetter = /[a-zA-Z]/.test(password);
    const hasNumber = /\d/.test(password);
    const hasSpecialChar = /[!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?]/.test(password);

    if (!hasLetter || !hasNumber || !hasSpecialChar) {
      return {
        isValid: false,
        error: "Password must be at least 6 characters long and contain a mix of letters, numbers, and special characters for better security."
      };
    }

    return {
      isValid: true,
      error: ""
    };
  }
};

export const textUtils = {
  truncate: (text, maxLength = 30) => {
    if (!text) return '-';
    return text.length > maxLength ? `${text.substring(0, maxLength)}...` : text;
  },

  capitalize: (text) => {
    if (!text) return '';
    return text.charAt(0).toUpperCase() + text.slice(1).toLowerCase();
  },

  formatCurrency: (amount) => {
    if (!amount) return 'Rp 0';
    return new Intl.NumberFormat('id-ID', {
      style: 'currency',
      currency: 'IDR',
      minimumFractionDigits: 0
    }).format(amount);
  }
};
